import React from 'react';
import { motion } from 'framer-motion';
import './WhyUs.css';

const advantages = [
  {
    icon: '⚡',
    title: 'Синергия инжиниринга и IT',
    desc: 'Уникальное сочетание компетенций: мы проектируем как физическую инфраструктуру объекта, так и цифровые продукты для его управления. Один подрядчик — полный спектр решений.',
  },
  {
    icon: '🎯',
    title: 'Индивидуальный подход',
    desc: 'Каждый проект начинается с глубокого погружения в задачу клиента. Мы не навязываем шаблонные решения — мы разрабатываем то, что действительно нужно вашему бизнесу.',
  },
  {
    icon: '📐',
    title: 'Высокое качество и надёжность',
    desc: 'Соответствие нормам и стандартам: все инженерные проекты выполняются по ПУЭ, ГОСТам и СНиПам. IT-разработка — с применением современных методологий и code review.',
  },
  {
    icon: '🔧',
    title: 'Полное сопровождение',
    desc: 'Мы сопровождаем проект на всех этапах: от технического задания и проектирования до реализации, ввода в эксплуатацию и последующей поддержки.',
  },
  {
    icon: '🌐',
    title: 'Кроссплатформенность',
    desc: 'Разрабатываемое нами ПО работает на всех платформах: Web, Windows, macOS и Linux. Ваши пользователи получают одинаково качественный опыт независимо от устройства.',
  },
  {
    icon: '⏱',
    title: 'Соблюдение сроков',
    desc: 'Чёткое планирование и прозрачная коммуникация на каждом этапе. Вы всегда знаете статус проекта и можете рассчитывать на выполнение работ в оговорённые сроки.',
  },
];

const processSteps = [
  { num: '01', title: 'Консультация', desc: 'Обсуждаем задачу, цели и ожидания' },
  { num: '02', title: 'Техническое задание', desc: 'Фиксируем требования и объём работ' },
  { num: '03', title: 'Проектирование', desc: 'Разрабатываем решение и согласовываем с вами' },
  { num: '04', title: 'Реализация', desc: 'Выполняем работы в срок с регулярной отчётностью' },
  { num: '05', title: 'Сдача', desc: 'Передаём готовый результат и обучаем при необходимости' },
];

export default function WhyUs() {
  return (
    <section className="section whyus" id="whyus">
      <div className="container">
        {/* Advantages */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="tag">ПОЧЕМУ МЫ</div>
          <div className="section-divider" style={{ marginTop: 16 }} />
          <h2 className="section-title">Наши <span>преимущества</span></h2>
          <p className="section-subtitle">
            ООО «ЭНЕРГОГЛАЙД» объединяет опыт строительной и IT-отраслей, предлагая
            клиентам комплексный подход к решению задач любой сложности.
          </p>
        </motion.div>

        <div className="whyus__grid">
          {advantages.map((a, i) => (
            <motion.div
              key={i}
              className="whyus__card card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              <span className="whyus__icon">{a.icon}</span>
              <h3 className="whyus__title">{a.title}</h3>
              <p className="whyus__desc">{a.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Process */}
        <motion.div
          className="whyus__process"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h3 className="whyus__process-title">Как мы работаем</h3>
          <div className="whyus__steps">
            {processSteps.map((step, i) => (
              <div key={i} className="whyus__step">
                <div className="whyus__step-num">{step.num}</div>
                <div className="whyus__step-content">
                  <div className="whyus__step-title">{step.title}</div>
                  <div className="whyus__step-desc">{step.desc}</div>
                </div>
                {i < processSteps.length - 1 && (
                  <div className="whyus__step-arrow">→</div>
                )}
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
